import { MaterialReactTable, useMaterialReactTable } from "material-react-table";

const CustomMRTTable = ({
  columns,
  data,
  loading,
  columnOrder,
  // Pagination props
  pagination,
  rowCount,
  onPaginationChange,

  // Search props
  searchInput,
  setSearchInput,
  onSearchEnter,
  placeholder,

  // Column filter props ✅ NEW
  columnFilters,
  onColumnFiltersChange,

  // Localization ✅ NEW (so "No records found" comes through)
  localization,

  // Feature toggles (ALL enabled by default)
  enablePagination = true,
  enableFiltering = true,
  enableSearch = true,
  enableSorting = true,
  enableColumnActions = true,
  enableColumnVisibility = true,
  enableDensityToggle = true,
  enableFullScreenToggle = true,
  enableHiding = true,
  enablePinning = false,
  enableRowSelection = false,
  enableStickyHeader = true,

  // Manual (server-side) mode
  manualPagination = true,
  manualFiltering = true,

  // Extra props passthrough
  ...rest
}) => {
  const tableConfig = {
    columns,
    data,

    // ─── Row Styling (alternate row colors) ───
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor: row.index % 2 === 0 ? "#f2f2f2" : "#fff",
      },
    }),

    // ─── Feature Toggles ───
    enablePagination,
    enableColumnFilters: enableFiltering,
    enableGlobalFilter: enableSearch,
    enableSorting,
    enableColumnActions,
    enableColumnOrdering: false,
    enableColumnPinning: enablePinning,
    enableRowSelection,
    enableDensityToggle,
    enableFullScreenToggle,
    enableHiding,
    enableStickyHeader,
    enableTopToolbar: true,
    enableBottomToolbar: enablePagination,

    // ─── Pagination ───
    manualPagination,
    manualFiltering,
    rowCount: manualPagination ? rowCount : undefined,
    onPaginationChange: manualPagination ? onPaginationChange : undefined,

    // ─── Column Filters (controlled) ✅ NEW ───
    onColumnFiltersChange: onColumnFiltersChange,

    // ─── Localization ✅ NEW ───
    localization,

    enableGlobalFilter: enableSearch,
    manualFiltering,
    // ─── State ───
    // state: {
    //   isLoading: loading,
    //   globalFilter: searchInput || "",
    //   ...(manualPagination && pagination ? { pagination } : {}),
    // },
    state: {
      isLoading: loading,
      globalFilter: searchInput || "",
      ...(columnOrder ? { columnOrder } : {}),   // ✅ APPLY ONLY IF EXISTS
      ...(manualPagination && pagination ? { pagination } : {}),
      ...(columnFilters !== undefined ? { columnFilters } : {}), // ✅ NEW
    },
    onGlobalFilterChange: (value) => {
      setSearchInput?.(value);
      if (!value) {
        onSearchEnter?.("");   // 🔥 THIS FIXES IT
      }
    },
    // ─── Global Search (Enter key trigger) ───
    muiSearchTextFieldProps: enableSearch
      ? {
          placeholder: placeholder,
          value: searchInput || "",
          onChange: (e) => setSearchInput?.(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              onSearchEnter?.(searchInput);
            }
          },
        }
      : undefined,

    // ─── Table Container Styling ───
    muiTableContainerProps: {
      sx: {
        maxHeight: enableStickyHeader ? "600px" : undefined,
      },
    },

    // ─── Table Paper Styling ───
    muiTablePaperProps: {
      sx: {
        boxShadow: "none",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
      },
    },

    // ─── Head Cell Styling ───
    muiTableHeadCellProps: {
      sx: {
        fontWeight: 600,
        fontSize: "0.85rem",
        backgroundColor: "#fafafa",
        borderBottom: "2px solid #e0e0e0",
      },
    },

    // ─── Body Cell Styling ───
    muiTableBodyCellProps: {
      sx: {
        fontSize: "0.85rem",
      },
    },

    // ─── Pagination Styling ───
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showFirstButton: true,
      showLastButton: true,
    },

    // ─── Initial State ───
    initialState: {
      density: "comfortable",
      showColumnFilters: enableFiltering,
      showGlobalFilter: enableSearch,
      ...(columnOrder ? { columnOrder } : {}),
      pagination: pagination || { pageIndex: 0, pageSize: 10 },
    },

    // ─── Spread any extra props ───
    ...rest,
  };

  const table = useMaterialReactTable(tableConfig);

  return <MaterialReactTable table={table} />;
};

export default CustomMRTTable;